import { isDefined } from "@clipboard-health/util-ts";
import type { WorkerCredentialSharedMessageProps } from "@src/appV2/Chat/type";
import { ChartingContextProvider } from "@src/appV2/Shifts/Shift/useGetChartingCredentials";

import { ChatWidgetWrapper } from "../../redesign/Chat/ChatWidgetWrapper";
import { WorkerCredentialSharedMessageCard } from "./WorkerCredentialSharedMessageCard";

export function WorkerCredentialSharedMessage(props: WorkerCredentialSharedMessageProps) {
  const { message, workplaceId, workerId } = props;
  const { data } = message;
  const messageData: unknown = isDefined(data) ? JSON.parse(data) : undefined;
  const workplaceName: string | undefined =
    typeof messageData === "object" &&
    isDefined(messageData) &&
    "workplaceName" in messageData &&
    typeof messageData.workplaceName === "string"
      ? messageData.workplaceName
      : undefined;

  const systemMessage = isDefined(workplaceName)
    ? `${workplaceName} shared charting login with you`
    : "A charting login has been shared with you";

  return (
    <ChartingContextProvider workerId={workerId} workplaceId={workplaceId}>
      <ChatWidgetWrapper headerText={systemMessage}>
        <WorkerCredentialSharedMessageCard workerId={workerId} workplaceId={workplaceId} />
      </ChatWidgetWrapper>
    </ChartingContextProvider>
  );
}
